/*
使用全局时间功能，和使用细化时间功能
 */

import event from "@/assets/event";
import {mapMutations, mapState} from "vuex";

const timeSelect = {
  data() {
    return {
    }
  },
  mounted() {
    this.form.trend = this.globalTimeTrend
    this.form.stage = this.globalTimeStage
    this.form.time.start = this.globalTimeBegin
    this.form.time.end = this.globalTimeEnd
    this.form.month = this.globalTimeMonth
    this.deletetime = this.$store.state.globalDeleteTime
    this.timedata()
  },
  activated() {
  },
  deactivated() {
  },
  created() {
  },
  beforeDestroy() {
  },
  computed:{
    ...mapState([
      'globalTimeTrend',
      'globalTimeStage',
      'globalTimeBegin',
      'globalTimeEnd',
      'globalTimeMonth',
      'globalDeleteTime'
    ])
  },
  watch: {
    globalTimeTrend (newVal){
      this.form.trend = this.globalTimeTrend
    },
    globalTimeStage () {
      this.form.stage = this.globalTimeStage
    },
    globalTimeBegin (newVal) {
      this.form.time.start = this.globalTimeBegin
    },
    globalTimeEnd (newVal) {
      this.form.time.end = this.globalTimeEnd
    },
    globalTimeMonth(newVal){
      this.form.month = this.globalTimeMonth
    },
    globalDeleteTime(newVal){
      this.deletetime = this.globalDeleteTime
    },
    'form.trend'(newVal) {
      this.setGlobalTimeTrend(newVal)
    },
    'form.stage'(newVal) {
      this.setGlobalTimeStage(newVal)
    },
    'form.time.start' (newVal) {
      this.setGlobalTimeBegin(newVal)
    },
    'form.time.end'(newVal) {
      this.setGlobalTimeEnd(newVal)
    },
    'form.month'(newVal) {
      this.setGlobalTimeMonth(newVal)
    },
    'deletetime'(newVal) {
      this.setGlobalDeleteTime(newVal)
    },
  },
  methods: {
    ...mapMutations([
      'setGlobalTimeTrend',
      'setGlobalTimeStage',
      'setGlobalTimeBegin',
      'setGlobalTimeEnd',
      'setGlobalTimeMonth',
      'setGlobalDeleteTime',
    ]),
  }
};

export default timeSelect;



// WEBPACK FOOTER //
// ./src/mixins/opPage/timeSelect.js